"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var system_1 = require("@mui/system");
var utils_1 = require("../../../utils");
function AlertIcon(_a) {
    var riskScore = _a.riskScore, _b = _a.snoozed, snoozed = _b === void 0 ? false : _b;
    var _c = (0, utils_1.riskScoreToSeverity)(riskScore, snoozed), icon = _c.icon, iconColor = _c.color;
    return ((0, jsx_runtime_1.jsx)(system_1.Box, __assign({ className: "alert-icon", sx: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: iconColor,
            backgroundColor: iconColor,
            borderRadius: '50%',
            width: '4.8rem',
            height: '4.8rem',
            top: '2.4rem',
            right: '2.4rem',
        } }, { children: icon })));
}
exports.default = AlertIcon;
